import React from 'react'

import { BaseSkeleton } from 'components/Skeleton'
import { ChartSkeleton, KpiSkeleton, KpiSkeletons, Root, SectionSkeleton } from './styled'

export default function AnalyticsSkeleton({ label }) {
  return (
    <Root aria-label={label}>
      <KpiSkeletons>
        {Array.from({ length: 8 }).map((_, index) => (
          <KpiSkeleton key={index}>
            <BaseSkeleton height={13} width="58%" />
            <BaseSkeleton height={34} width="42%" />
          </KpiSkeleton>
        ))}
      </KpiSkeletons>
      <ChartSkeleton>
        <BaseSkeleton height={22} width={220} />
        <BaseSkeleton height={280} width="100%" borderRadius={12} />
      </ChartSkeleton>
      <SectionSkeleton>
        <BaseSkeleton height={22} width={180} />
        <BaseSkeleton count={5} height={38} width="100%" />
      </SectionSkeleton>
    </Root>
  )
}
